'use client';

import React, { useEffect } from 'react';

interface SuccessModalProps {
  visible: boolean;
  naam?: string;
  onClose: () => void;
  autoCloseMs?: number;
}

export default function SuccessModal({ visible, naam, onClose, autoCloseMs = 6000 }: SuccessModalProps) {
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => {
      onClose();
    }, autoCloseMs);
    return () => clearTimeout(timer);
  }, [visible, autoCloseMs, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center space-y-5 animate-[fadeInUp_0.3s_ease-out]">
        <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
          <svg className="w-9 h-9 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 className="text-2xl font-extrabold text-foreground">Bedankt{naam ? `, ${naam}` : ''}!</h3>
        <p className="text-lg font-semibold text-foreground">Uw aanvraag is succesvol verzonden.</p>
        <p className="text-base text-muted-foreground leading-relaxed">
          <strong className="text-foreground">Wij nemen contact op</strong> — u hoort van ons binnen 24 uur.
        </p>
        <div className="bg-secondary/50 rounded-xl p-4 text-sm text-muted-foreground space-y-1">
          <p>📞 Of bel ons direct: <a href="tel:0498545474" className="font-bold text-primary hover:underline">0498 54 54 74</a></p>
          <p>💬 <a href="https://wa.me/32498545474" target="_blank" rel="noopener noreferrer" className="font-bold text-green-600 hover:underline">WhatsApp ons</a></p>
        </div>
        <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-emerald-500 rounded-full"
            style={{ animation: `shrink ${autoCloseMs}ms linear forwards` }}
          />
        </div>
        <p className="text-xs text-muted-foreground">Dit venster sluit automatisch...</p>
        <button
          onClick={onClose}
          className="w-full bg-primary text-white py-3 rounded-full font-bold text-sm hover:opacity-90 transition-opacity"
        >
          Sluiten
        </button>
      </div>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
}
